import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import banner1 from "../../../Assets/slider/samanthaWeb.webp";
import banner2 from "../../../Assets/slider/mainbanner2.webp";
import banner3 from "../../../Assets/slider/mainbanner3.webp";
import diwaliBanner from "../../../Assets/slider/diwaliPik.webp";
//import SamBanner from "../../../Assets/newAsset/newImgs/newBg.webp";
import Samanbanner from "../../../Assets/slider/banner111.webp";

//desktopSamImg.webp
import samantha from "../../../Assets/newAsset/newImgs/desktopSamImg.webp";
import "./ModalTest";
import "../Components/Slider.css";
import { MdLocationOn } from "react-icons/md";

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useDispatch, useSelector } from "react-redux";

import LpForm from "../../packageDetailsPage/LpForm";

import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Slider = ({ match }) => {
  // const location = useLocation();

  // var url = `https://redcliffelabs.com` + location.pathname;

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  // const packageDetails = useSelector((state) => state.packageDetails);
  // const { loading, packDetail } = packageDetails;

  const BannerImages = [
    {
      id: 1,
      img: banner1,
      title: "India's Trusted Lab",
      subtitle: "One Stop Solution For Healthy India's Diagnostic Needs",
      button_title: "Find Health Packages",
    },
    {
      id: 2,
      img: banner2,
      title: "India's Trusted Lab",
      subtitle: "One Stop Solution For Healthy India's Diagnostic Needs",
      button_title: "Book Arthiritis Package",
    },
    {
      id: 3,
      img: banner3,
      title: "India's Trusted Lab",
      subtitle: "One Stop Solution For Healthy India's Diagnostic Needs",
      button_title: "Book Fever Profile Package",
    },
  ];

  return (
    <div className="sliderMainDiv">
      <Carousel
        autoPlay={false}
        showIndicators={false}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        interval={2500}
        infiniteLoop={false}
        transitionTime={1000}
        preventMovementUntilSwipeScrollTolerance={false}
        swipeScrollTolerance={150}
      >
        <div className="sliderImg">
          <div className="BookNowBtn1">
            <div className="TexT1">
              <span className="red1">Think Radiology</span>
              <span className="red1">CHECKUP</span>
              <span className="textwhite">@ Just Rs. 699</span>
            </div>
            <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
              BOOK TEST NOW
            </button>
          </div>
          <div className="saman_quote">
            <span className="quotwhite">
              "Road to happy life passes through a
            </span>
            <span className="quotwhite">healthy body and calm mind"</span>
            <span className="quotboldwhite">- Samantha</span>
          </div>

          <LazyLoadImage
            className="bannerImg"
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/906c9471-8278-452d-ae86-fc0b7df012af.webp"        
              alt="bannerphoto"
            delayTime="100"
          />

          {/* <LazyLoadImage src={banner1} /> */}
          <Modal open={open} onClose={onCloseModal} center>
            <LpForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            />
          </Modal>
        </div>
        {/* <div className="sliderImg">
          <div className="BookNowBtn1">
            <div className="TexT1">
              <span className="smalltext">Now</span>
              <span className="red1">HYDERABAD</span>
              <span className="textwhite">WILL ALSO CHOOSE</span>
              <span className="BGwhite">TEST FROM HOME</span>
            </div>
            <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
              Find Health Packages
            </button>
          </div>
          <div className="saman_quote">
            <span className="quotwhite">
              "Road to happy life passes through a
            </span>
            <span className="quotwhite">healthy body and calm mind"</span>
            <span className="quotboldwhite">- Samantha</span>
          </div>
          <img src={Samanbanner} alt="bannerphoto" />
          <Modal open={open} onClose={onCloseModal} center>
            <LpForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            />
          </Modal>
        </div> */}

        {/* <div className="sliderImg">
          <div className="BookNowBtn">
            <div className="TexT">
              <span className="descr">
                Old Age Comes With Many Complications{" "}
              </span>
              <span className="HeAding">
                Let Arthritis<span className="redone">Not</span>
              </span>
              <span className="HeAding">Be One.</span>
              <span className="subHeAding">Get Your Parents Tested Today!</span>
            </div>
            <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
              Book Arthritis Packages
            </button>
          </div>
          <LazyLoadImage
            className="bannerImg"
            src={
              "https://staticcdn.redcliffelabs.com/media/gallary-file/None/4a7a0c78-866f-4187-a8a5-749e0ca542f9.webp"
            }
            alt="bannerphoto"
            delayTime="100"
          />

          <Modal open={open} onClose={onCloseModal} center>
            <LpForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            />
          </Modal>
        </div>
        <div className="sliderImg">
          <div className="BookNowBtn">
            <div className="TexT">
              <span className="descr">
                Shield Your Loved Ones From Dengue And Malaria{" "}
              </span>
              <span className="HeAding">
                <span className="redtwo">Net</span>Your Loved{" "}
              </span>
              <span className="HeAding">Ones Today.</span>
              <span className="subHeAding">Get Your Parents Tested Today!</span>
            </div>
            <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
              Book Fever Profile Test
            </button>
          </div>
          <a
            href="https://youtu.be/AFRZXhFoXHE"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <LazyLoadImage
                className="bannerImg"
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-file/None/a3b44869-96a8-4911-89f8-0f031a350ad7.webp"
                }
                alt="bannerphoto"
                delayTime="100"
              />
            </div>
          </a>

          <Modal open={open} onClose={onCloseModal} center>
            <LpForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            />
          </Modal>
        </div>
        <div className="sliderImg">
          <div className="BookNowBtn">
            <div className="TexT">
              <span className="descr">
                Shield Your Loved Ones From Dengue And Malaria{" "}
              </span>
              <span className="HeAding">
                <span className="redtwo">Net</span>Your Loved{" "}
              </span>
              <span className="HeAding">Ones Today.</span>
              <span className="subHeAding">Get Your Parents Tested Today!</span>
            </div>
            <button onClick={onOpenModal} style={{ cursor: "pointer" }}>
              Book Fever Profile Test
            </button>
          </div>
          <a
            // href="javascript: void(0)"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <LazyLoadImage
                className="bannerImg"
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6ce8fe40-4325-41ad-936c-b714bb2afbc8.webp"
                }
                alt="bannerphoto"
                delayTime="100"
              />
            </div>
          </a>

          <Modal open={open} onClose={onCloseModal} center>
            <LpForm
              butname={"SUBMIT"}
              title={"Book Your Test"}
              position={"Banner"}
            />
          </Modal>
        </div> */}
        {/**new samantha */}
      </Carousel>
    </div>
  );
};

export default Slider;
